// extracted by mini-css-extract-plugin
export default {"page":"eU","headerwrap":"fU","headerblock":"gU","textwrapper":"hU","text":"iU","closerlook":"jU","arrowwrap":"kU","icon":"lU","updown":"mU","products":"nU","system":"oU","systemimage":"pU","cards":"qU","note":"rU","fadein":"sU"};
    if(module.hot) {
      // 1730991510120
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  